module.exports = __webpack_public_path__ + "static/media/faq2x1.9b6c85dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq2x1.png
// module id = 1267
// module chunks = 1